import React, { useState } from 'react'
import AddSubscription from './AddSubscription/AddSubscription'
import AddPaymentSubscription from './AddPaymentSubscription/AddPaymentSubscription'
import SubscriptionAdded from './SubscriptionAdded/SubscriptionAdded'
import useSubscriptionStore from './SubscriptionStore'
import { useMutation } from 'react-query'
import { updateAccountPlan } from '../../../Api/index' // adjust the import path as needed
import { useQuery } from 'react-query'
import { getAccount } from '../../../Api/index'
import UpdateSubscription from './UpdateSubscription/UpdateSubscription'
import UpdateSubscriptionAdded from './UpdateSubscriptionAdded/UpdateSubscriptionAdded'
import PaymentUpgradeSubscription from './AddPaymentSubscriptionUpgrade/AddPaymentSubscriptionUpgrade'

export default function SubscriptionIndex ({ setShowSubscriptionModal }) {
  const [step, setStep] = useState('plan')
  const { selectedPlan, setIsModalHidden } = useSubscriptionStore()
  // const { data: AccountData ,refetch } = useQuery('account', getAccount)
  const { data: account, refetch } = useQuery('account', getAccount)
  const hasPeoplePlan = !!account?.data?.plans?.find(
    p => p.dataType === 'people'
  )

  // Create a mutation to update the subscription plan
  const [updatePlan, { isLoading }] = useMutation(
    planState => updateAccountPlan(planState),
    {
      onSuccess: async data => {
        if (data?.status === 200) {
          const checkPlan = async () => {
            const result = await refetch()
            if (result?.data?.plan_ids?.includes(selectedPlan)) {
              setIsModalHidden(true)
              setStep('added')
              // setTimeout(() => {
              // console.log("Update PLAN ADDED about to happen")
              // }, 250)
            } else {
              setTimeout(checkPlan, 1000)
            }
          }
          checkPlan()
          setIsModalHidden(false)
        } else if (data?.status === 400) {
          setIsModalHidden(true)
          // setTimeout(() => {
            setStep('payment')
          // }, 250)
        }
        setIsModalHidden(false)
      },
      onError: () => {}
    }
  )

  const [updateExistingPlan, { isLoading: isUpdating }] = useMutation(
    payload => updateAccountPlan(payload),
    {
      onSuccess: async data => {
        if (data?.status === 200) {
          // Confirm the new plan is recognized
          const checkPlan = async () => {
            const result = await refetch()
            const freshPlanIds = result?.data?.plan_ids || []
            if (freshPlanIds.includes(selectedPlan)) {
              // Show the "UpdateSubscriptionAdded" success flow
              setIsModalHidden(true)
              // setTimeout(() => {
                setStep('update-added')
              // }, 250)
            } else {
              setTimeout(checkPlan, 2000)
            }
            setIsModalHidden(false)
          }
          checkPlan()
        } else if (data?.status === 400) {
          // Possibly requires payment details
          setIsModalHidden(true)
          // setTimeout(() => {
            setStep('payment-upgrade')
          // }, 250)
        }
        setIsModalHidden(false)
      },
      onError: err => {
        // Handle error if needed
      }
    }
  )

  // Callback for when the plan modal should continue
  const handlePlanContinue = () => {
    if (selectedPlan) {
      updatePlan({ plan_ids: [selectedPlan] })
    }
  }

  const handleUpdatePlanContinue = () => {
    if (selectedPlan) {
      updateExistingPlan({ plan_ids: [selectedPlan] })
    }
  }
  // Callback to close all modals (or complete the workflow)
  const handleCloseAll = () => {
    setTimeout(() => {
      setStep(null)
      setShowSubscriptionModal(false)
      setIsModalHidden(false)
    }, 250)
  }

  const handleCloseOnClick = () => {
    setStep(null)
    setShowSubscriptionModal(false)
    setIsModalHidden(false)
  }

  return (
    <>
      {step === 'plan' &&
        (hasPeoplePlan ? (
          <UpdateSubscription
            onContinue={handleUpdatePlanContinue}
            isLoading={isUpdating}
            handleCloseOnClick={handleCloseOnClick}
          />
        ) : (
          <AddSubscription
            onContinue={handlePlanContinue}
            isLoading={isLoading}
            handleCloseOnClick={handleCloseOnClick}
          />
        ))}
      {step === 'payment' && (
        <AddPaymentSubscription
          onContinue={handlePlanContinue}
          handleCloseOnClick={handleCloseOnClick}
        />
      )}
      {step === 'added' && (
        <SubscriptionAdded
          onClose={handleCloseAll}
          handleCloseOnClick={handleCloseOnClick}
        />
      )}
      {step === 'update-added' && (
        <UpdateSubscriptionAdded
          onClose={handleCloseAll}
          handleCloseOnClick={handleCloseOnClick}
        />
      )}

      {step === 'payment-upgrade' && (
        <PaymentUpgradeSubscription
          onContinue={handleUpdatePlanContinue}
          handleCloseOnClick={handleCloseOnClick}
        />
      )}
    </>
  )
}
